import React, { useState, useEffect } from "react";
import { Eye, EyeOff } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import axios from "axios";
import { baseurl } from "../Baseurl";
import Swal from "sweetalert2";

const CustomerLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("Stored ID:", localStorage.getItem("cust_id"));
    console.log("Stored Name:", localStorage.getItem("cust_name"));
    console.log("Stored Email:", localStorage.getItem("cust_email"));
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const loginData = { email, password };
    console.log("Sending Data:", loginData);

    try {
      const response = await axios.post(`${baseurl}customerLogin`, loginData);
      console.log("Login Response:", response.data);

      if (
        (response.status === 200 || response.data.success) &&
        response.data.message === "Login successful."
      ) {
        const { id, first_name, email } = response.data.data;

        // Save to localStorage
        localStorage.setItem("cust_id", id);
        localStorage.setItem("cust_name", first_name);
        localStorage.setItem("cust_email", email);

        // ✅ SweetAlert Toast
        Swal.fire({
          toast: true,
          icon: "success",
          title: "Login successful!",
          position: "top-end",
          showConfirmButton: false,
          timer: 1800,
          timerProgressBar: true,
        });

        // Delay navigation slightly so toast appears smoothly
        setTimeout(() => {
          navigate(-1); // go back
          // navigate("/customer/profile"); // if preferred
        }, 400);

        return;
      } else {
        Swal.fire({
          icon: "error",
          title: "Login Failed",
          text: response.data.message || "Invalid credentials",
        });
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError("Something went wrong. Please try again.");

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to login. Try again later.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <VisitorNavbar />
      <div>
        <section className="mb-5">
          <div className="container">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Login to Name</h4>
                  <p className="payttl">
                    Please log in using your email and password.
                  </p>
                  <hr />

                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-2">
                      
                      <div className="col-12">
                        <label htmlFor="email" className="form-label">
                          Email Address <span className="text-danger">*</span>
                        </label>
                        <input
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="password" className="form-label">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type={showPassword ? "text" : "password"}
                            id="password"
                            className="form-control"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                          <span
                            className="input-group-text"
                            onClick={togglePasswordVisibility}
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <EyeOff /> : <Eye />}
                          </span>
                        </div>
                      </div>
                    </div>

                    {error && <p className="text-danger mt-2">{error}</p>}

                    <div className="mt-3">
                      <button type="submit" className="btn submitbtnn w-100" disabled={loading}>
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </div>
                  </form>

                  <div className="mt-1 text-center">
                    <p>
                      <Link to="/customer/forget-password" className="text-dark bvc">
                        Forget password?
                      </Link>
                    </p>
                  </div>

                  <div className="mt-2 text-center">
                    <p>
                      No account yet?{" "}
                      <Link to="/customer/create-account" className="text-dark bvc">
                        Create Account
                      </Link>
                    </p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default CustomerLogin;
